import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = auth.isAuthenticated();
  const isTokenExpired = auth.isTokenExpired();

  if (!isAuthenticated || isTokenExpired) {
    auth.clearToken(); // centralizes clearing logic
    return router.createUrlTree(['/sign-in'], {
      queryParams: { returnUrl: state.url || '/home' }
    });
  }

  return true;
};
